import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, FuncaoService, Imovel } from 'eddydata-lib';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BemImovelService extends BaseResourceService<Imovel> {

  constructor(
    protected injector: Injector
  ) {
    super(`imoveis`, injector);
  }

  public obterPorNome(nome: string, orgaoId: number): Observable<Imovel> {
    return this.http.get<Imovel>(
      `${this.login.cidade.id}/${this.api}/filtrar?nome$like=${nome}%&orgao_id=${orgaoId}&relations=unidade`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public obterFiltro(descricaoImovel?: string, matricula?: string, cep?: string, bairro?: string, municipio?: string, secretaria?: string): {} {
    const parametros = {};

    if (descricaoImovel)
      parametros['descricao$like'] = `%${new FuncaoService().removerAcentos(descricaoImovel)}%`;
    if (matricula)
      parametros['matricula'] = matricula;
    if (cep)
      parametros['cep'] = cep;
    if (bairro)
      parametros['bairro$like'] = `%${new FuncaoService().removerAcentos(bairro)}%`;
    if (municipio)
      parametros['municipio$like'] = `%${new FuncaoService().removerAcentos(municipio)}%`;
    if (secretaria)
      parametros['setor.unidade.nome$like'] = `%${new FuncaoService().removerAcentos(secretaria)}%`;

    return parametros;
  }

  public listagemGeralDeImoveis(pagina: number, limite: number, param): Observable<any> {
    let query = `?paginaCorrente=${pagina - 1}&limite=${limite}`;
    query += `&orgao=${this.login.orgao.id}`;
    query += `&orderBy=${param.orderBy}`;

    if (param['dataInicial']) query += `&dataInicial=${param['dataInicial']}`;
    if (param['dataFinal']) query += `&dataFinal=${param['dataFinal']}`;
    if (param['tipoRelatorio']) query += `&tipoRelatorio=${param['tipoRelatorio']}`;
    if (param['placa$like']) query += `&placaLike=${param['placa$like'].replace('%', '')}`;
    if (param['placa$ge']) query += `&placaInicial=${param['placa$ge']}`;
    if (param['placa$le']) query += `&placaFinal=${param['placa$le']}`;
    if (param['setor.id']) query += `&setor=${param['setor.id']}`;
    if (param['setor.unidade.id']) query += `&unidade=${param['setor.unidade.id']}`;
    if (param['plano_conta.codigo']) query += `&despesa=${param['plano_conta.codigo']}`;
    if (param['matricula$like']) query += `&matricula=${param['matricula$like'].replace(/\%/g, '')}`;
    if (param['descricao$like']) query += `&descricao=${param['descricao$like'].replace(/\%/g, '')}`;

    return this.http.get<any>(`${this.login.cidade.id}/${this.api}/listagem-geral-de-imoveis/${query}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

}
